<template>
  <div class="box">
    <div class="box-title">
      <h1>手机号注册</h1>
    </div>
    <a-form :form="form" @click="handleSubmit">
      <a-form-item>
        <a-input placeholder="手机号" v-decorator="formRules.username" size="large">
          <a-icon slot="prefix" type="user" class="i-icon"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-row :gutter="4">
          <a-col :span="14">
            <a-input placeholder="验证码" v-decorator="formRules.code" size="large"/>
          </a-col>
          <a-col :span="10">
            <a-button type="primary" ghost size="large" block :disabled="disabled" html-type="button" @click="handleSmsSend()" :loading="smsLoading">{{ btnTxt }}</a-button>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item>
        <a-input-password type="password" placeholder="密码" v-decorator="formRules.password1" size="large">
          <a-icon slot="prefix" type="lock" class="i-icon"/>
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-input-password type="password" placeholder="确认密码" v-decorator="formRules.password2" size="large">
          <a-icon slot="prefix" type="lock" class="i-icon"/>
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" block size="large" @click="handleSubmit" :loading="btnLoading">确 认</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="link" @click="$router.push({ path: '/register' })">用户名注册</a-button>
        <a-button type="link" @click="$router.push({ path: '/login' })">返回登录</a-button>
      </a-form-item>
    </a-form>
    <xs-id-card-bind :visible="idCardBindDialogVisible" @next="handleBindIdCardNext"></xs-id-card-bind>
  </div>
</template>

<script>
import api from '@/api'
import XsIdCardBind from '@/components/XsIdCardBind'

export default {
  components: {
    XsIdCardBind
  },
  data () {
    return {
      disabled: false,
      btnTxt: '发送验证码',
      timer: null,
      btnLoading: false,
      smsLoading: false,
      idCardBindDialogVisible: false,
      gameUrl: '',
      form: this.$form.createForm(this, { name: 'normal_sms_register' }),
      formRules: {
        username: [
          'username',
          {
            rules: [{
              required: true,
              message: '请输入手机号！'
            }]
          }
        ],
        code: [
          'code',
          {
            rules: [{
              required: true,
              message: '请输入验证码！'
            }]
          }
        ],
        password1: [
          'password1',
          {
            rules: [{
              required: true,
              message: '请输入密码！'
            }]
          }
        ],
        password2: [
          'password2',
          {
            rules: [{
              required: true,
              message: '请再次输入密码！'
            }]
          }
        ]
      }
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    channelId () {
      return this.$store.getters.channelId
    },
    os () {
      return this.$store.getters.os
    },
    deviceId () {
      return this.$store.getters.deviceId
    }
  },
  methods: {
    handleSmsSend () {
      this.form.validateFields(['username'], (err, values) => {
        if (err) {
          return
        }
        const phone = values.username
        if (phone.length !== 11) {
          this.$message.error('手机号格式错误，请重新输入')
          return
        }
        const params = {
          appId: this.appId,
          type: 'register',
          phone: phone
        }
        this.smsLoading = true
        // http 请求
        api.smsCodeSend(params).then(res => {
          this.smsLoading = false
          if (res.code !== 200) {
            this.$message.error(res.msg)
          } else {
            this.$message.success('验证码发送成功')
            this.time = 60
            this.timerTask()
          }
        }).catch(() => {
          this.smsLoading = false
        })
      })
    },
    // 发送手机验证码倒计时
    timerTask () {
      if (this.time > 0) {
        this.disabled = true
        this.time--
        this.btnTxt = this.time + '秒'
        this.timer = setTimeout(this.timerTask, 1000)
      } else {
        this.time = 0
        this.btnTxt = '发送验证码'
        this.disabled = false
      }
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        if (values.password1 !== values.password2) {
          this.$message.warning('两次密码不一致')
          return
        }
        const params = {
          appId: this.appId,
          type: 2,
          channelId: this.channelId,
          username: values.username,
          password: values.password1,
          extra: values.code,
          deviceId: this.deviceId,
          os: this.os
        }
        this.btnLoading = true
        // http 请求
        api.h5Register(params).then(res => {
          this.btnLoading = false
          // const code = res.code || 0
          const { code, msg, data } = res
          if (code !== 1) {
            const message = msg || '用户名密码错误'
            this.$message.error(message)
          } else {
            this.$store.dispatch('SaveAccountInfo', data).then(() => {
              this.$message.success('注册成功')
              this.gameUrl = data.gameUrl
              // 0 关闭防沉迷, 1/2 开启防沉迷 弹出实名认证
              const juvenileSwitch = data.juvenileSwitch || 0
              if (juvenileSwitch !== 0) {
                this.showBindIdCardDialog()
              } else {
                window.location.href = data.gameUrl
              }
            })
          }
        }).catch(() => {
          this.btnLoading = false
        })
      })
    },
    showBindIdCardDialog () {
      this.idCardBindDialogVisible = true
    },
    handleBindIdCardNext (data) {
      this.idCardBindDialogVisible = false
      const { playable, tips } = data
      if (!playable) {
        this.$message.error(tips)
        return
      }
      window.location.href = this.gameUrl
    }
  },
  destroyed () {
    clearTimeout(this.timer)
  }
}
</script>
